import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Grid,
  Typography,
  FormControl,
  Box,
  CircularProgress,
  TextField,
  FormLabel,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Iconify from "src/components/iconify";
import { createBlobInContainer } from "src/utils/azureBlob";

// ----------------------------------------------------------------------

export default function NewLeaguePage() {
  const fields = [
    { title: "Title", name: "title" },
    { title: "League Type", name: "league_type" }
  ];
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    title: "",
    league_type: "",
    league_image_en: "",
    league_image_fr: "",
    league_image_sk: "",
    league_image_ee: "",
    league_image_lv: "",
    league_image_ru: "",
    league_image_nl: "",
    league_image_de: "",
    league_image_es: "",
  });
  const [isFilled, setFilling] = useState(true);

  useEffect(() => {
    const count = Object.values(data).filter(
      (field) => field.length <= 0
    ).length;
    if (!count || data.name) setFilling(true);
    else setFilling(false);
  }, [data]);

  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const uploadFiles = (event, name) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;

      let uploadPromises = [];
      uploadPromises.push(createBlobInContainer(files[0]));

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);

          const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
          const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
          setData((prevState) => ({
            ...prevState,
            [name]: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${files[0].name}`,
          }));
        };

        uploadFiles().catch(console.error);
      }
    }
  };

  const handleSubmit = () => {
    if (!!data) {
      setLoading(true);
      axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/admin/conferences`,
          data
        )
        .then(function (response) {
          navigate("/dashboard/conferences");
        });
    }
  };


  return (
    <>
      <Helmet>
        <title> Conference </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Create Conference
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <FormLabel id="card-format-label">League Image EN</FormLabel>
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="label"
                >
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={(event) => uploadFiles(event, "league_image_en")}
                  />
                  <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
                </IconButton>
                {data.league_image_en ? (
                  <img
                    style={{
                      margin: "0 auto",
                      width: 100,
                      background: "grey",
                    }}
                    alt=""
                    src={data.logo}
                  />
                ) : null}
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                {fields.map((field) => (
                  <FormControl
                    key={field.name}
                    sx={{ m: 1, minWidth: 620 }}
                    size="small"
                  >
                    <TextField
                      required
                      label={field.title}
                      placeholder={field.title}
                      name={field.name}
                      value={data[field.name] || ""}
                      onChange={(e) => handleChange(e)}
                      variant="outlined"
                    />
                  </FormControl>
                ))}
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  disabled={!isFilled}
                  onClick={() => handleSubmit()}
                >
                  Create
                </Button>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
